import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TimeComparisonCounterComponent } from './time-comparison-counter/time-comparison-counter.component';
import { TimeCounterComponent } from './time-counter/time-counter.component';

@NgModule({
    declarations: [TimeCounterComponent, TimeComparisonCounterComponent],
    imports: [CommonModule],
    exports: [TimeCounterComponent, TimeComparisonCounterComponent]
})
export class TimeCounterModule {}
